import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import assets from '../admin/crudFunctions/assets'

const TechPanel = () => {
  const history = useHistory()
  const [loading, setLoading] = useState<boolean>(true)
  const wakeEndpoint: string = 'client/wake'
  const wakeUrl: string = assets.apiUrl + wakeEndpoint

  const logout = (): void => {
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    history.push({ pathname: '/tecnico/login' })
  }

  useEffect(() => {
    fetch(wakeUrl).then(() => setLoading(false))
  }, [wakeUrl])

  return (
    <div className='container grid justify-items-center mx-auto my-auto'>
      {loading ? (
        <div className='loader animate-spin mt-40'></div>
      ) : (
        <>
          <Link to='/tecnico/crear-cliente' className='w-11/12 mt-20'>
            <button
              type='button'
              className='bg-gray-200 active:bg-gray-300 rounded-lg h-20 w-full items-center justify-center text-4xl flex'>
              Nuevo Cliente
              <div className='bg-gray-400 text-white text-6xl rounded-full ml-5 h-16 w-16 flex items-center justify-center'>
                +
              </div>
            </button>
          </Link>

          <Link to='/tecnico/crear-reporte' className='w-11/12 h-auto mt-20'>
            <button
              type='button'
              className='bg-viper w-full text-white active:bg-gray-800 rounded-lg h-20 items-center justify-center text-4xl flex'>
              Nuevo Reporte
              <div className='bg-gray-700 text-white text-6xl rounded-full ml-5 h-16 w-16 flex items-center justify-center'>
                +
              </div>
            </button>
          </Link>
          <button
            type='button'
            onClick={logout}
            className='mt-96 border-solid border-2 border-black rounded-full h-14 w-80 text-center text-3xl'>
            Salir
          </button>
        </>
      )}
    </div>
  )
}

export default TechPanel
